import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  makeStyles,
} from '@material-ui/core';
import FolderIcon from '@material-ui/icons/Folder';


const useStyles = makeStyles((theme) => ({
  buttonFolderStepper: {
    color: 'white',
    marginLeft: '15px'
  },
  iconFolderStepper: {
    fontSize: '15px',
    color: 'white'
  },
  buttonFolderStepperActive: {
    color: '#f60',
    marginLeft: '15px'
  },
  iconFolderStepperActive: {
    fontSize: '15px',
    color: '#f60'
  }
}));


export default function FolderStepper(props) {
  const classes = useStyles();
  const [folderStepper, setFolderStepper] = useState([]);

  useEffect(() => {
    let folders = appendFolderStepper(props.folderName);
    setFolderStepper(folders);
  }, [props.folderName]);

  const appendFolderStepper = (data) => {
    let folders = folderStepper;
    if(folders.filter(x => x.name === data).length > 0)
      return folders;
    let position = 1;
    if (folders.length > 1)
      position = (Math.max.apply(Math, folders.map(function (o) { return o.position; }))) + 1;
    folders.map(a => a.isActive = false);
    folders.push({
      name: data,
      position: position,
      isActive: true
    });
    folders = folders.sort(function (a, b) {
      return a.position - b.position
    });
    return folders;
  }

  const removeExcessFolderStepper = (data) => {
    let folders = folderStepper;
    folders = folders.filter(x => x.position <= data.position);
    return folders;
  }

  const setActiveFolderStepper = (data, folders) => {
    let selectedFolder = folders.filter(x => x.position === data.position)[0];
    selectedFolder.isActive = true;
    folders = folders.filter(x => x.position !== data.position);
    folders.push(selectedFolder);
    folders = folders.sort(function (a, b) {
      return a.position - b.position
    });
    return folders;
  }

  const handleClickFolderStepper = async (data) => {
    let folders = removeExcessFolderStepper(data);
    folders = setActiveFolderStepper(data, folders);
    props.clickFolderStepperCallback(data);
    if (data.position > 1)
      setFolderStepper(folders);
    else
      setFolderStepper([{
        name: 'ALT',
        position: 1,
        isActive: true
      }]);
  }

  return (
    <Grid container>
      {
        folderStepper.map(item => {
          return (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleClickFolderStepper(item);
              }}
              className={item.isActive === false ?
                classes.buttonFolderStepper :
                classes.buttonFolderStepperActive}
              type="button"
              startIcon={<FolderIcon className={item.isActive === false ?
                classes.iconFolderStepper :
                classes.iconFolderStepperActive} />}
            >
              {item.name}
            </Button>
          )
        })
      }

    </Grid>
  );
}
